import SocialShare from 'utils/SocialShare'
function install (Vue) {
  let twttrSharing = function (infos) {
  }
  Vue.directive('sharebox', {
    update (el, params, vnode) {
      if (params.value) {
        let service = params.value.service
        let opts = params.value.opts
        // Add Click Listener
        let serviceUrl = SocialShare.network[service].url
        el.href = SocialShare.generateUrl(serviceUrl, opts)
        // console.log(SocialShare.generateUrl(serviceUrl, opts))
        // addClickListener()
        el.clickHandler = SocialShare.doPopup.bind(el)
        el.addEventListener('click', el.clickHandler)
      }
    },
    inserted (el, params, vnode) {
      if (params.value) {
        let service = params.value.service
        let opts = params.value.opts
        // Add Click Listener
        let serviceUrl = SocialShare.network[service].url
        el.href = SocialShare.generateUrl(serviceUrl, opts)
        // console.log(SocialShare.generateUrl(serviceUrl, opts))
        // addClickListener()
        el.clickHandler = SocialShare.doPopup.bind(el)
        el.addEventListener('click', el.clickHandler)
      }
    },
    unbind (el) {
      el.removeEventListener('click', el.clickHandler)
      el.clickHandler = null
    }
  })
}
if (window.Vue) {
  Vue.use(install)
}
module.exports = install



/** WEBPACK FOOTER **
 ** ./src/plugins/VueShareBox.js
 **/